<div
  id="footer"
  class="footer bg-mat-ef-revolution-primary-500 flex justify-center"
  >
  <div class="container">
    <div
      class="md:pb-5 lg:py-10 flex flex-col lg:flex-row items-center justify-between"
      >
      <customer-portal-app-brand></customer-portal-app-brand>
      @if (!isMobilePwa) {
        <customer-portal-app-social
        ></customer-portal-app-social>
      }
    </div>

    <customer-portal-app-divider
      class="footerDivider hidden lg:block"
    ></customer-portal-app-divider>

    @if (!isMobilePwa) {
      <div class="md:pb-5 lg:py-10 flex items-center">
        <customer-portal-app-links class="grow"></customer-portal-app-links>
      </div>
    }

    <customer-portal-app-divider
      class="footerDivider"
    ></customer-portal-app-divider>

    <div class="md:py-5 lg:py-10 flex items-center">
      <customer-portal-app-impressum></customer-portal-app-impressum>
    </div>

    @if (isUserCentricEnabled()) {
      <customer-portal-app-divider
        class="footerDivider"
      ></customer-portal-app-divider>
      <div class="md:py-5 lg:py-10 flex items-center">
        <div class="footerLinks text-mat-ef-revolution-supergrey-500">
          <div class="p-6 md:p-0 grid grid-cols-1 md:grid-cols-4 gap-4 text-xxs">
            <span class="cursor-pointer"
              (click)="openPrivacySettings()"
              (keydown.enter)="openPrivacySettings()"
              >
              <T
              str="Privacy settings"
              key="customerPortal.customer-portal.footer-privacy-settings"
              tags="customer-portal, 3.38"
            ></T>
          </span>
        </div>
      </div>
    </div>
  }
</div>
</div>
